import React from 'react';
import { DEVICE_TYPES } from '../../common/constant/common-constants';
import "./VitalDetailsContainer.scss";
import { MonitorVitalData } from '../../components/VitalData/MonitorVitalData';
import { NX5_MonitorVitalData } from '../../components/VitalData/NX5_MonitorVitalData';
import VentilatorVitalData from '../../components/VitalData/VentilatorVitalData';
import DevicesTab from '../PatientRightPanel/MachineTabs/DevicesTab';

function VitalDetailsContainer(props) {
    const {alarmData, handleSeeAllAlarms, activeVitalDevice, setActiveVitalDevice, ventilatorModesData } = props;
    // useEffect(()=>{
    //     if (!bedId){
    //         setBedId(props.bedId);
    //     } else {
    //         if (bedId !== props.bedId) {
    //             //setActiveVitalDevice(DEVICE_TYPES.MONITOR);
    //             window.location.reload()
    //         }
    //     }
    //     //window.location.reload()
    //     //setActiveVitalDevice(DEVICE_TYPES.MONITOR);
    // },[props.bedId]);

    return (
        <div className='vitals-data-container'>
            <DevicesTab 
                alarmData={alarmData}
                handleSeeAllAlarms={handleSeeAllAlarms}
                activeVitalDevice={activeVitalDevice}
                setActiveVitalDevice={setActiveVitalDevice}
                modeData={ventilatorModesData}
                bedId={props.bedId}
            />
            {activeVitalDevice === DEVICE_TYPES.NOCCARC_PM_NX5 &&
                // <MonitorVitalData
                //     bedId={props.bedId}
                //     monitorHeartBeatData={props.monitorHeartBeatData}
                //     monitorEcgWaveFormData={props.monitorEcgWaveFormData}
                //     monitorHrWaveFormData={props.monitorHrWaveFormData}
                //     vitalData={props.vitalData}
                // />
                <NX5_MonitorVitalData
                    bedId={props.bedId}
                    monitorHeartBeatData={props.monitorHeartBeatData}
                    monitorEcgWaveFormData={props.monitorEcgWaveFormData}
                    monitorRespWaveFormData={props.monitorRespWaveFormData}
                    monitorPlethWaveFormData={props.monitorPlethWaveFormData}


                    vitalData_ECG={props.vitalData_ECG}
                    vitalData_SPO2={props.vitalData_SPO2}
                    vitalData_NIBP={props.vitalData_NIBP}
                    vitalData_TEMP={props.vitalData_TEMP}

                />
                }
            {activeVitalDevice === DEVICE_TYPES.VENTILATOR &&
                <VentilatorVitalData
                    bedId={props.bedId}
                />}
        </div>
    );
}

export default VitalDetailsContainer;